(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nx-anelo-hero"] && !Shopify.designMode) return;
  try {
    
  if ('customElements' in window && !customElements.get('nx-anelo-scene')) {
    customElements.define('nx-anelo-scene', class extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;
        this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._film = this.querySelector('.nx-anelo-scene__film');
        this._play = this.querySelector('.nx-anelo-scene__play');
        this._stage = this.querySelector('.nx-anelo-scene__stage');
        this._src = this.getAttribute('data-film') || '';
        this._saveData = !!(navigator.connection && navigator.connection.saveData);
        if (this._film && this._src) this._setupFilm();
        if (window.Shopify?.designMode || this._motion.matches || this._saveData || !('IntersectionObserver' in window)) {
          this._revealDone = true;
        }
        if (!('IntersectionObserver' in window)) { this._startFilm(); return; }
        this._observer = new IntersectionObserver(entries => {
          this._visible = entries.some(entry => entry.isIntersecting);
          if (this._visible) {
            this._reveal();
            this._startFilm();
          } else if (this._film && !this._film.paused) {
            this._film.pause();
            this._pausedByScroll = true;
          }
        }, { threshold: .12, rootMargin: '0px 0px -5% 0px' });
        this._observer.observe(this);
        this._onMotion = () => { if (this._motion.matches) { this._finishReveal(); if (this._film && !this._film.paused && !this._userPlay) this._film.pause(); } };
        this._motion.addEventListener('change', this._onMotion);
        this.addEventListener('focusin', () => this._finishReveal());
      }
      _setupFilm() {
        const film = this._film;
        film.muted = true;
        film.defaultMuted = true;
        film.loop = true;
        film.playsInline = true;
        film.addEventListener('playing', () => {
          this.setAttribute('data-film-ready', '');
          this._syncPlay(true);
        });
        film.addEventListener('pause', () => this._syncPlay(false));
        film.addEventListener('error', () => {
          this.removeAttribute('data-film-ready');
          this._filmFailed = true;
          if (this._play) this._play.hidden = true;
        });
        if (this._play) {
          this._play.addEventListener('click', () => {
            if (!film.paused) { this._userPause = true; this._userPlay = false; film.pause(); return; }
            this._userPlay = true; this._userPause = false;
            if (this._filmFailed) { this._filmFailed = false; film.removeAttribute('src'); film.load(); }
            this._load();
            film.play().catch(() => this._showPlay(false));
          });
        }
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) { if (!film.paused) { film.pause(); this._pausedByScroll = true; } }
          else if (this._visible && this._pausedByScroll) this._startFilm();
        });
      }
      _load() {
        if (this._loaded || !this._film) return;
        this._loaded = true;
        this._film.src = this._src;
        this._film.load();
      }
      _startFilm() {
        if (!this._film || !this._src || this._userPause) return;
        const auto = !(this._motion.matches || this._saveData);
        if (!auto && !this._userPlay) { this._showPlay(false); return; }
        this._pausedByScroll = false;
        this._load();
        const attempt = this._film.play();
        if (attempt && attempt.catch) attempt.catch(() => this._showPlay(false));
      }
      _showPlay(playing) {
        if (!this._play) return;
        this._play.hidden = false;
        this._syncPlay(playing);
      }
      _syncPlay(playing) {
        if (!this._play || this._play.hidden) return;
        if (playing) this._play.setAttribute('data-playing', ''); else this._play.removeAttribute('data-playing');
        this._play.setAttribute('aria-label', playing ? this._play.getAttribute('data-label-pause') : this._play.getAttribute('data-label-play'));
      }
      _reveal() {
        if (this._revealDone || this._revealRunning || !this.isConnected) return;
        const image = this.querySelector('.nx-anelo-scene__image');
        if (image && !(image.complete && image.naturalWidth > 0)) {
          image.addEventListener('load', () => { if (this._visible) this._reveal(); }, { once: true });
          image.addEventListener('error', () => this._finishReveal(), { once: true });
          return;
        }
        this._revealRunning = true;
        this.classList.add('is-revealing');
        this._timer = window.setTimeout(() => this._finishReveal(), 1400);
      }
      _finishReveal() {
        this._revealDone = true;
        window.clearTimeout(this._timer);
        this.classList.remove('is-revealing');
      }
      disconnectedCallback() {
        this._finishReveal();
        this._observer?.disconnect();
        this._motion?.removeEventListener('change', this._onMotion);
        if (this._film && !this._film.paused) this._film.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-header"]) return;
  try {
    
document.addEventListener('click', event => {
  if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
  const link = event.target.closest('a[data-nx-travel-link]');
  if (!link) return;
  const destination = new URL(link.href, window.location.href);
  if (destination.origin !== window.location.origin || destination.pathname !== window.location.pathname) return;
  const target = document.getElementById(destination.hash.slice(1));
  if (!target) return;
  event.preventDefault();
  const menu = link.closest('dialog');
  if (menu?.open) menu.close();
  const fallback = link.closest('.nx-menu-fallback');
  if (fallback) fallback.open = false;
  window.location.hash = destination.hash;
  target.focus({preventScroll:true});
  target.scrollIntoView({block:'start'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  function linkDiscovery() {
    const target = document.getElementById('nx-discovery');
    document.querySelectorAll('[data-nx-discovery-link]').forEach(link => {
      if (!link.dataset.discoveryFallback) link.dataset.discoveryFallback = link.getAttribute('href');
      link.setAttribute('href', target ? '#nx-discovery' : link.dataset.discoveryFallback);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', linkDiscovery, { once: true });
  else linkDiscovery();
  document.addEventListener('shopify:section:load', linkDiscovery);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(linkDiscovery));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-home-lineup"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.CSS && CSS.supports && CSS.supports('animation-timeline: view()')) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  const sections = document.querySelectorAll('[data-nx-lineup]');
  if (!sections.length) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
  sections.forEach(section => {
    section.classList.add('nx-lineup--js');
    section.querySelectorAll('.nx-lineup__reveal').forEach(element => observer.observe(element));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-home-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.CSS && CSS.supports && CSS.supports('animation-timeline: view()')) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  const sections = document.querySelectorAll('[data-nx-story]');
  if (!sections.length) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
  sections.forEach(section => {
    section.classList.add('nx-story--js');
    section.querySelectorAll('.nx-story__reveal').forEach(element => observer.observe(element));
  });
})();

  } catch(e) { console.error(e); }
})();
})();
